export default "__VITE_ASSET__d34e3659__"